module.exports = __webpack_public_path__ + "img/fruit.6f5eda62.png";